import * as z from "zod";

export const sendTestPoEmail = {
  name: "sendTestPoEmail" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean(), message: z.string() }),
};
